module.exports = __webpack_public_path__ + "e0a894a6fb7d174c7fdece5ec195ef1a.svg";